
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/portfolio-monitoring",
      function () {
        return require("private-next-pages/use-cases/portfolio-monitoring.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-cases/portfolio-monitoring"])
      });
    }
  